module.exports = __webpack_public_path__ + "static/media/MartenDB.60470514.png";